import React, { useEffect, useState } from "react";
import { Card, Table, Typography, Tag, Alert } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import axiosInstance from "../../configs";

const { Title, Text } = Typography;

export default function MyActivity() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);


    useEffect(() => {
        const loadActivity = async () => {
            try {
                // Debug: check token
                const token = localStorage.getItem('token');
                console.log('[MyActivity] Token exists:', !!token);
                console.log('[MyActivity] Token preview:', token ? token.substring(0, 30) + '...' : 'NO TOKEN');

                console.log('[MyActivity] Calling /logs/my...');
                const res = await axiosInstance.get("/logs/my", {
                    params: { limit: 100 },
                    skipRedirect: true  // Prevent auto-redirect on error
                });
                console.log('[MyActivity] Response received:', res.data?.length, 'logs');
                setData(res.data || []);
                setError(null);
            } catch (err) {
                console.error("[MyActivity] Load activity error:", err);
                console.error("[MyActivity] Error response:", err.response);
                console.error("[MyActivity] Error status:", err.response?.status);
                console.error("[MyActivity] Error data:", err.response?.data);
                setError(err.response?.data?.error || err.message || "Gagal memuat data aktivitas");
            } finally {
                setLoading(false);
            }
        };
        loadActivity();
    }, []);


    const getActivityColor = (activity) => {
        const colors = {
            'LOGIN': 'green',
            'LOGOUT': 'default',
            'CREATE': 'blue',
            'UPDATE': 'orange',
            'DELETE': 'red',
            'VIEW': 'cyan',
            'DOWNLOAD': 'purple',
            'PRINT': 'magenta'
        };
        return colors[activity?.toUpperCase()] || 'default';
    };

    const columns = [
        {
            title: "Tanggal",
            dataIndex: "tgl",
            key: "tgl",
            width: 120,
            render: (val) => val ? new Date(val).toLocaleDateString("id-ID") : "-"
        },
        {
            title: "Waktu",
            dataIndex: "waktu",
            key: "waktu",
            width: 100,
            render: (val) => val || "-"
        },
        {
            title: "Aktivitas",
            dataIndex: "activity",
            key: "activity",
            width: 120,
            render: (val) => <Tag color={getActivityColor(val)}>{val}</Tag>
        },
        {
            title: "Modul",
            dataIndex: "module",
            key: "module",
            width: 150
        },
        {
            title: "Detail",
            dataIndex: "details",
            key: "details",
            ellipsis: true,
            render: (val) => <Text type="secondary">{val || "-"}</Text>
        },
        {
            title: "IP Address",
            dataIndex: "ip_address",
            key: "ip_address",
            width: 130
        }
    ];

    return (
        <Card>
            <div style={{ marginBottom: 24, display: "flex", alignItems: "center" }}>
                <HistoryOutlined style={{ fontSize: 24, marginRight: 12, color: "#1890ff" }} />
                <Title level={4} style={{ margin: 0 }}>My Activities</Title>
            </div>

            {error && (
                <Alert
                    message="Error"
                    description={error}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                />
            )}

            <Table
                dataSource={data}
                columns={columns}
                rowKey={(r, i) => r.id_log || i}
                loading={loading}
                pagination={{ pageSize: 20 }}
                size="middle"
            />
        </Card>
    );
}
